import React from 'react';
import './SearchBar.css';
import { ReactComponent as SearchIcon } from '../../../assets/Blog/Blog home/Search.svg'; // Import your SVG file

const SearchBar = ({ value, onChange, onSearch }) => {
  return (
    <div className="search-bar-container">
      <input
        type="text"
        className="search-bar"
        placeholder="Search..."
        value={value}
        onChange={onChange}
        onKeyPress={(e) => {
          if (e.key === 'Enter' && onSearch) {
            onSearch(); // Trigger on pressing Enter key
          }
        }}
      />
      <span className="search-bar-icon" onClick={onSearch}>
        <SearchIcon />
      </span>
    </div>
  );
};

export default SearchBar;
